<template>
  <div></div>
</template>
<script>

export default {
    props: {
        // 授权完毕后-重定向地址-相对路径
        redirectUri: {
            type: String,
            default: ''
        },
        // 授权主题公众号ID
        appid: {
            type: String,
            default: ''
        },
        responseType: {
            type: String,
            default: 'code'
        },
        scope: {
            type: String,
            default: 'snsapi_base'
        },
        // 存储在本地缓存的key名
        openidKey: {
            type: String,
            default: ''
        },
        // 存储在本地缓存的key名
        unionidKey: {
            type: String,
            default: ''
        }
    },
    methods: {
        getAppId () {
            return this.$route.query.appId || this.appid
        },
        // 申请授权，获取code值
        getCode () {
            // 授权完毕跳转的目标地址
            const local = this.redirectUri
            const APPID = this.getAppId()
            const RESPONSE_TYPE = this.responseType
            const SCOPE = this.scope
            window.location = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${encodeURIComponent(local)}&response_type=${RESPONSE_TYPE}&scope=${SCOPE}#wechat_redirect`
        },
        /**
         * 解析url参数
         * @param {String} name 参数key
         * @returns {String | null}
         */
        getQueryVariable (name) {
            const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
            const r = window.location.search.substr(1).match(reg)
            if (r != null) {
                return decodeURI(r[2])
            }
            return null
        }
    },
    async mounted () {
        const openidKey = this.openidKey
        const unionidKey = this.unionidKey
        if (openidKey) {
            // 判断openId是否存在 不存在则去授权
            const openId = localStorage.getItem(openidKey)
            if (!openId || openId === 'undefined') {
                // 授权回来获得的code值 用于给后端 获取openId
                const code = this.getQueryVariable('code')
                if (code) {
                    const res = await this.$api.commonGetGzhOpenId({ code, appId: this.getAppId() })
                    if (res) {
                        const { status, result } = res
                        if (status) {
                            this.$store.dispatch('vipCoach/setWxOpenId', result.openId)
                            localStorage.setItem(openidKey, result.openId)
                            localStorage.setItem(unionidKey, result.unionId)
                        }
                    }
                } else {
                    this.getCode()
                }
            }
        }
    }
}
</script>
